// export const breakpoints = [360, 720, 1080, 1440]
// SIZES:                  [ xs,  sm,  md,    l,   xl]
export const breakpoints = [360, 540, 769, 1080, 1440]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)
export { mq }
